import createApiClient from "./api";
import { deleteCookie } from "./clientStorageActions";
const api = createApiClient();
export const get = async (url: string, body?: any, baseURL?: string, headers?:any) => {
  try {
    const response = await api.get(
      url,
      {
        params: body,
      },
      baseURL,
      headers
    );

    return response;
  } catch (error) {
    //@ts-ignore
    if (error?.status === 401) {
      deleteCookie("accessToken");
    }
    throw error;
  }
};

export const post = async (url: string, body: any, baseURL?: string, headers?:any) => {
  try {
    const response = await api.post(url, body ?? {}, baseURL, headers);
    return response;
  } catch (error) {
    //@ts-ignore
    if (error?.status === 401) {
      deleteCookie("accessToken");
    }
    throw error;
  }
};

export const del = async (url: string, body: any, baseURL?: string, headers?:any) => {
  try {
    const response = await api.delete(url, { params: body }, baseURL, headers);
    return response;
  } catch (error) {
    //@ts-ignore
    if (error?.status === 401) {
      deleteCookie("accessToken");
    }
    throw error;
  }
};

export const put = async (url: string, body: any, baseURL?: string,headers?:any) => {
  try {
    const response = await api.put(url, body, baseURL, headers);
    return response;
  } catch (error) {
    //@ts-ignore
    if (error?.status === 401) {
      deleteCookie("accessToken");
    }
    throw error;
  }
};
